import { render, staticRenderFns } from "./busquedaRuc.vue?vue&type=template&id=49aaf1cd&scoped=true"
import script from "./busquedaRuc.vue?vue&type=script&lang=js"
export * from "./busquedaRuc.vue?vue&type=script&lang=js"
import style0 from "./busquedaRuc.vue?vue&type=style&index=0&id=49aaf1cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aaf1cd",
  null
  
)

export default component.exports